import React from 'react';
import { useState, useEffect } from 'react';
import { withSnackbar } from 'notistack';

import RoleForm from './RoleForm';
import { loadRolesConfig, createRole, loadCompany } from './services';

let CreateRole = ({ match, history, enqueueSnackbar, updateBreadcrumbs }) => {
    const { company_id: companyId } = match.params;
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        loadCompany(companyId).then(company =>
            updateBreadcrumbs([
                { name: 'Companies', path: '/companies' },
                {
                    name: company.business_name,
                    path: `/companies/${companyId}`,
                },
                'New Role',
            ])
        );
        loadRolesConfig().then(roles => setRoles(roles));
    }, []);

    const handleSave = async data => {
        setLoading(true);
        try {
            await createRole(data, companyId);
            enqueueSnackbar('Partner portal role was added', {
                variant: 'info',
            });
            handleCancel();
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = () =>
        history.push(`/companies/${companyId}/partner/roles`);

    return (
        <RoleForm
            mode="edit"
            loading={loading}
            roles={roles}
            onSave={handleSave}
            onCancel={handleCancel}
        />
    );
};

export default withSnackbar(CreateRole);
